export class DeleteUsers {
    static readonly type = '[User] DeleteUsers';

    constructor(
        public payload: {
            entityIds: string[];
        }
    ) {}
}
